<script lang="ts">
  import { Col, Image, Row } from "sveltestrap";
  import EmailWrapper from "./EmailWrapper.svelte";
  let imgPath:string = "/assets/images/user"
</script>

<Col xl="9" md="12" class="xl-70 box-col-8">
    <div class="email-right-aside">
        <div class="card email-body">
            <div class="email-profile">      
                <div class="email-right-aside">
                    <div class="email-body">
                        <div class="email-content">
                            <div class="email-top">
                                <Row>
                                    <Col xl="12">
                                    <div class="media">
                                        <Image class="me-3 rounded-circle" src="{imgPath}/user.png" alt="" />
                                        <div class="media-body">
                                                <h6 class="d-block">{'Lorm lpsa'}</h6>
                                                <p>{'Mattis luctus. Donec nisi diam text.'}</p>
                                        </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <EmailWrapper />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</Col>